import React from 'react';
import styles from './index.css';
class Offline extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        return (React.createElement("section", { className: styles.offline },
            React.createElement("div", { className: styles.offlineBox },
                React.createElement("span", { className: styles.icon }),
                React.createElement("a", { href: "https://i.ifeng.com/", className: styles.btn }, "\u53BB\u624B\u673A\u51E4\u51F0\u7F51\u770B\u770B"))));
    }
}
export default Offline;
